import { Component, Input, Output, EventEmitter } from '@angular/core';
import { ActivationResultComponent } from '@src/base-components/activation/steps/result/activation-result';

@Component({
    selector: 'app-activation-result-bellross',
    templateUrl: './activation-result.html'
})
export class ActivationResultComponentBellRoss extends ActivationResultComponent { }
